<template>
  <div :style="maxHeight" @mousewheel="getMaxHeight" style="overflow-y: auto;overflow-x: hidden">
  <el-button type="primary">{{ $t('makeSchedule.zlProduceActualPage.wujianSelect') }}</el-button>
  <el-select v-model="wuJianId" style="width: 200px;margin-left: 10px" clearable @change="renderAllEcharts" :placeholder="$t('makeSchedule.zlProduceActualPage.wujianName')" class="wujian_select_size">
    <el-option
        v-for="item in wuJianNames"
        :key="item.value"
        :label="item.label"
        :value="item.value">
    </el-option>
  </el-select>

    <el-row style="height:45%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="divSize" v-loading="totalOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height:90%;margin-top: 30px" id="totalOutput"/>
      </el-col>

      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <el-row>
          <el-col :span="4" style="margin-left: 10px">
            <el-select v-model="lineDayId" @change="getLineDayOutput" clearable placeholder="产线"  style="width: 140px">
              <el-option
                  v-for="item in lineNames"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" style="margin-left: 10px">
            <el-date-picker v-model="lineDay.day" @change="getLineDayOutput" format="YYYY 年 M 月"
                            value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px"
                            :clearable="false"/>
          </el-col>
        </el-row>
        <div class="divSize" v-loading="lineDayOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height: 90%;" id="lineDayOutput"/>
      </el-col>
    </el-row>

    <el-row style="height:50%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div style="margin-left: 10px">
          <el-date-picker v-model="productionData.day" @change="getAllProduction" format="YYYY 年 M 月"
                          value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px"
                          :clearable="false"/>
          <el-button @click="nextPage(this.showPage)"  icon="el-icon-arrow-right-bold" style="font-size: 25px;margin-left: 65%;color: #0a84ff"></el-button>
        </div>
        <!--  生产实绩-->
        <div v-if="showPage === 'zl'" class="divSize" v-loading="zuliProductionOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height: 90%;" id="zuliProductionOutput"/>
        <!--  组立面积生产实绩-->
        <div v-if="showPage === 'zl_area'" class="divSize" v-loading="zuliAreaProductionOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height: 90%;" id="zuliAreaProductionOutput"/>

      </el-col>

      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <el-date-picker  v-model="productiveData.day" @change="getDayProductiveOutput" format="YYYY 年 M 月"
                        value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;margin-left: 10px"
                        :clearable="false"/>
        <div class="divSize" v-loading="zuliProductiveOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height: 90%" id="zuliProductiveOutput"/>
      </el-col>
    </el-row>


    <el-row style="height:45%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <el-date-picker v-model="zuliAreaProductionData.day" @change="getZuliAreaProductionScheduling" format="YYYY 年 M 月"
                        value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;margin-left: 10px"
                        :clearable="false"/>
        <div class="divSize" v-loading="zuliAreaProductionSchedulingOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height:90%;" id="zuliAreaProductionSchedulingOutput"/>
      </el-col>

      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <el-date-picker v-model="zuliProductionData.day" @change="getZuliProductionScheduling" format="YYYY 年 M 月"
                        value-format="YYYY-M-1" type="month" placeholder="选择月份" style="width: 140px;margin-left: 10px"
                        :clearable="false"/>
        <div class="divSize" v-loading="zuliProductionSchedulingOutputLoading" element-loading-text="数据加载中"
             style="width: 100%;height: 90%;" id="zuliProductionSchedulingOutput"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "MfgZuLiProduceActual",
  data() {
    return {
      maxHeight:'',
      showPage:'zl_area',
      wuJianNames: [],
      lineNames: [],
      wuJianId: '',
      lineDayId: '',
      lineDay: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      productionData: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      productiveData: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      zuliAreaProductionData: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      zuliProductionData: {
        day: this.getDateFormat(),
        wuJianId: ''
      },
      //组立产量
      totalOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlProductionWujian'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: { bottom: '20',},
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'套数',
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.production'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      totalOutputLoading: false,
      //组立日产量
      lineDayOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlProductionDay'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'套数',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.production'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      lineDayOutputLoading: false,
      //物件日生产实绩
      zuliProductionOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlAchievementsCnt'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'套数',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.zlProduceActualPage.totalCnt'),
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.plan'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.achievements'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          // {
          //   name: '面积',
          //   type: 'line',
          //   color: '#00ccff',
          //   yAxisIndex: 1,
          //   areaStyle: {
          //     opacity: 0.4
          //   },
          //   tooltip: {
          //     valueFormatter: function (value) {
          //       return value;
          //     }
          //   },
          //   data: []
          // },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalPlan'),
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalAchievements'),
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliProductionOutputLoading: false,
      //物件日生产性
      zuliProductiveOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlProductivity'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.zlProduceActualPage.area'),
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.zlProduceActualPage.productivity'),
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.production'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: '工数',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.area1'),
            type: 'line',
            connectNulls: true,  // 连接空数据点
            color: '#00ccff',
            areaStyle: {
              opacity: 0.4
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.targetProductivity'),
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.achievementsProductivity'),
            type: 'line',
            color: '#ee6666',
            connectNulls: true,  // 连接空数据点
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalProductivity'),
            color: '#9932CD',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliProductiveOutputLoading: false,

      //物件日生产面积实绩
      zuliAreaProductionOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlAchievementsArea'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.zlProduceActualPage.area'),
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name:this.$t('makeSchedule.zlProduceActualPage.totalArea'),
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.plan'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.achievements'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalPlan'),
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalAchievements'),
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliAreaProductionOutputLoading: false,

      //排产物件日生产实绩
      zuliProductionSchedulingOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlAchievementsSchedulingCnt'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'套数',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name: this.$t('makeSchedule.zlProduceActualPage.totalCnt'),
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.planScheduling'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.achievements'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          // {
          //   name: '面积',
          //   type: 'line',
          //   color: '#00ccff',
          //   yAxisIndex: 1,
          //   areaStyle: {
          //     opacity: 0.4
          //   },
          //   tooltip: {
          //     valueFormatter: function (value) {
          //       return value;
          //     }
          //   },
          //   data: []
          // },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalPlan'),
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalAchievements'),
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliProductionSchedulingOutputLoading: false,

      //物件日生产面积实绩
      zuliAreaProductionSchedulingOutput: {
        title: [
          {
            text: this.$t('makeSchedule.zlProduceActualPage.zlAchievementsSchedulingArea'),
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          bottom: '20',
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.$t('makeSchedule.zlProduceActualPage.area'),
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name:this.$t('makeSchedule.zlProduceActualPage.totalArea'),
            min: 0,
            max: 10,
            interval: 0.5,
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: this.$t('makeSchedule.zlProduceActualPage.planScheduling'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.achievements'),
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalPlan'),
            type: 'line',
            color: '#fac858',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
          {
            name: this.$t('makeSchedule.zlProduceActualPage.totalAchievements'),
            type: 'line',
            color: '#ee6666',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: []
          },
        ]
      },
      zuliAreaProductionSchedulingOutputLoading: false,
    }
  },
  methods: {
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight -160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id, option) {
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
      }
    },
    renderAllEcharts(){
      this.getTotalOutput()
      this.getLineDayOutput()
      this.getZuliProduction()
      this.getDayProductiveOutput()
      this.getZuliAreaProduction()
      this.getZuliAreaProductionScheduling()
      this.getZuliProductionScheduling()
    },
    getAllProduction(){
      this.getZuliProduction()
      this.getZuliAreaProduction()
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    async getLineInFo() {
      let {data: res} = await this.$axios.post('am/homePage/getLineInFo');
      if (res.code !== 0) {
        this.$message.error('获取【产线信息】失败')
        return;
      }
      this.lineNames = res.data;
    },
    nextPage(value){
      if ("zl" === value){
        this.showPage = 'zl_area'
        this.getZuliAreaProduction()
      }
      if ("zl_area" === value){
        this.showPage = 'zl'
        this.getZuliProduction()
      }
      this.pauseTimer()
    },

    //组立产量-物件别
    async getTotalOutput() {
      let query = {
        wuJianId: this.wuJianId,
      }
      this.totalOutputLoading = true
      let {data: res} = await this.$axios.post('am/homePage/getTotalOutput', query);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.totalOutput.xAxis[0].data = res.data.xAxis
        this.totalOutput.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.totalOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.series) / a) * (a + 3)
        this.totalOutput.yAxis[0].interval = Math.round(this.totalOutput.yAxis[0].max / 5 * 100) / 100
      }
      this.renderEcharts('totalOutput', this.totalOutput)

      this.totalOutputLoading = false
    },

    //产线日产量
    async getLineDayOutput() {
      if (!this.lineDay.day) {
        this.lineDay.day = this.getDateFormat()
      }
      this.lineDay.wuJianId = this.wuJianId
      this.lineDayOutputLoading = true
      this.lineDay.lineDayId = this.lineDayId
      let {data: res} = await this.$axios.post('am/homePage/getLineDayOutput', this.lineDay);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.lineDayOutput.xAxis[0].data = res.data.xAxis
        this.lineDayOutput.series[0].data = res.data.series
        let a = this.$common.getDivisor(Math.max(...res.data.series))
        this.lineDayOutput.yAxis[0].max = Math.ceil(Math.max(...res.data.series) / a) * (a + 3)
        this.lineDayOutput.yAxis[0].interval = Math.round(this.lineDayOutput.yAxis[0].max / 5 * 100) / 100
      }
      this.renderEcharts('lineDayOutput', this.lineDayOutput)

      this.lineDayOutputLoading = false
    },

    //生产实绩
    async getZuliProduction() {

      if (!this.productionData.day) {
        return this.$message.error('请先选择物件月份!')
      }
      this.productionData.wuJianId = this.wuJianId
      this.zuliProductionOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliActualProduction/getZuliProduction', this.productionData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliProductionOutput.xAxis[0].data = res.data.xAxis
        this.zuliProductionOutput.series[0].data = res.data.planList
        this.zuliProductionOutput.series[1].data = res.data.actualList
        this.zuliProductionOutput.series[2].data = res.data.accumulatePlanList
        this.zuliProductionOutput.series[3].data = res.data.accumulateActualList

        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)
        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)
        this.zuliProductionOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliProductionOutput.yAxis[0].interval = Math.round(this.zuliProductionOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliProductionOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliProductionOutput.yAxis[1].interval = Math.round(this.zuliProductionOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliProductionOutput', this.zuliProductionOutput)
      this.zuliProductionOutputLoading = false
    },

    //物件生产性
    async getDayProductiveOutput() {
      if (!this.productiveData.day) {
        return this.$message.error('请先选择物件月份!')
      }
      this.productiveData.wuJianId = this.wuJianId
      this.zuliProductiveOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliProductive/getzuliProductive', this.productiveData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliProductiveOutput.xAxis[0].data = res.data.xAxis
        this.zuliProductiveOutput.series[0].data = res.data.produceNum
        this.zuliProductiveOutput.series[1].data = res.data.produceArtificial
        this.zuliProductiveOutput.series[2].data = res.data.produceArea
        this.zuliProductiveOutput.series[3].data = res.data.targetProductivity
        this.zuliProductiveOutput.series[4].data = res.data.actualProductivity
        this.zuliProductiveOutput.series[5].data = res.data.accumulateProductivity

        let maxA = this.$common.getMaxValue1(res.data.produceNum,res.data.produceArtificial,res.data.produceArea)
        let maxB = this.$common.getMaxValue1(res.data.targetProductivity,res.data.actualProductivity,res.data.accumulateProductivity)

        this.zuliProductiveOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliProductiveOutput.yAxis[0].interval = Math.round(this.zuliProductiveOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliProductiveOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliProductiveOutput.yAxis[1].interval = Math.round(this.zuliProductiveOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliProductiveOutput', this.zuliProductiveOutput)

      this.zuliProductiveOutputLoading = false
    },

    //面积生产实绩
    async getZuliAreaProduction() {

      if (!this.productionData.day) {
        return this.$message.error('请先选择物件月份!')
      }
      this.productionData.wuJianId = this.wuJianId
      this.zuliAreaProductionOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliActualProduction/getZuliAreaProduction', this.productionData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliAreaProductionOutput.xAxis[0].data = res.data.xAxis
        this.zuliAreaProductionOutput.series[0].data = res.data.planList
        this.zuliAreaProductionOutput.series[1].data = res.data.actualList
        this.zuliAreaProductionOutput.series[2].data = res.data.accumulatePlanList
        this.zuliAreaProductionOutput.series[3].data = res.data.accumulateActualList

        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)
        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)
        this.zuliAreaProductionOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliAreaProductionOutput.yAxis[0].interval = Math.round(this.zuliAreaProductionOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliAreaProductionOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliAreaProductionOutput.yAxis[1].interval = Math.round(this.zuliAreaProductionOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliAreaProductionOutput', this.zuliAreaProductionOutput)
      this.zuliAreaProductionOutputLoading = false
    },

    //排产面积生产实绩
    async getZuliAreaProductionScheduling() {

      if (!this.zuliAreaProductionData.day) {
        return this.$message.error('请先选择物件月份!')
      }
      this.zuliAreaProductionData.wuJianId = this.wuJianId
      this.zuliAreaProductionSchedulingOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliProductive/getZuliAreaProductionScheduling', this.zuliAreaProductionData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliAreaProductionSchedulingOutput.xAxis[0].data = res.data.xAxis
        this.zuliAreaProductionSchedulingOutput.series[0].data = res.data.planList
        this.zuliAreaProductionSchedulingOutput.series[1].data = res.data.actualList
        this.zuliAreaProductionSchedulingOutput.series[2].data = res.data.accumulatePlanList
        this.zuliAreaProductionSchedulingOutput.series[3].data = res.data.accumulateActualList

        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)
        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)
        this.zuliAreaProductionSchedulingOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliAreaProductionSchedulingOutput.yAxis[0].interval = Math.round(this.zuliAreaProductionSchedulingOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliAreaProductionSchedulingOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliAreaProductionSchedulingOutput.yAxis[1].interval = Math.round(this.zuliAreaProductionSchedulingOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliAreaProductionSchedulingOutput', this.zuliAreaProductionSchedulingOutput)
      this.zuliAreaProductionSchedulingOutputLoading = false
    },

    //排产生产实绩
    async getZuliProductionScheduling() {

      if (!this.zuliProductionData.day) {
        return this.$message.error('请先选择物件月份!')
      }
      this.zuliProductionData.wuJianId = this.wuJianId
      this.zuliProductionSchedulingOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/zuliProductive/getZuliProductionScheduling', this.zuliProductionData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.zuliProductionSchedulingOutput.xAxis[0].data = res.data.xAxis
        this.zuliProductionSchedulingOutput.series[0].data = res.data.planList
        this.zuliProductionSchedulingOutput.series[1].data = res.data.actualList
        this.zuliProductionSchedulingOutput.series[2].data = res.data.accumulatePlanList
        this.zuliProductionSchedulingOutput.series[3].data = res.data.accumulateActualList

        let maxA = this.$common.getMaxValue(res.data.planList,res.data.actualList)
        let maxB = this.$common.getMaxValue(res.data.accumulatePlanList,res.data.accumulateActualList)
        this.zuliProductionSchedulingOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.zuliProductionSchedulingOutput.yAxis[0].interval = Math.round(this.zuliProductionSchedulingOutput.yAxis[0].max / 5 * 100) / 100

        this.zuliProductionSchedulingOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.zuliProductionSchedulingOutput.yAxis[1].interval = Math.round(this.zuliProductionSchedulingOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('zuliProductionSchedulingOutput', this.zuliProductionSchedulingOutput)
      this.zuliProductionSchedulingOutputLoading = false
    },
  },
  mounted() {
    this.getTotalOutput()
    this.getLineDayOutput()
    this.getZuliProduction()
    this.getDayProductiveOutput()
    this.getZuliAreaProduction()
    this.getZuliAreaProductionScheduling()
    this.getZuliProductionScheduling()
  },
  created() {
    this.getWuJianInFo()
    this.getLineInFo()
    this.getMaxHeight()

  }
}
</script>

<style scoped>
.divSize {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>